import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'safeURL' })
export class SafeURLPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }

  public transform(value: string) {
    return this.sanitized.bypassSecurityTrustResourceUrl(value);
  }
}